import { FISH_RECIPES } from '../constants'
import { appLoading, appMessage } from './appActions'
import { DB } from '../firebase'

export const getFishRecipes = (fishId) => dispatch => {
  DB.collection('fishRecipes')
  .where("fishId", "==", fishId)
  .onSnapshot( result => {
    result = result.docs.map(r => ({ ...r.data(), id: r.id }))
    dispatch({ type: FISH_RECIPES, payload: result })
  })
}

export const updateRecipeData = (recipeData) => async(dispatch) => {
  dispatch(appLoading(true))
  await DB.collection('fishRecipes').doc(recipeData.id).set(recipeData)
  dispatch(appLoading(false))
  dispatch({ type: 'changedDataHandledByListenerAlready' })
}


export const addNewRecipe = (recipeData) => async(dispatch) => {
  dispatch(appLoading(true))
  DB.collection('fishRecipes').add(recipeData)
    .then( () => {
      dispatch(appMessage(`{ok}`))
    })
    .catch( err => {
      dispatch(appMessage(`Wystąpił błąd ${"\n"}Błąd systemu to: ${err.message}`))
    })
}

export const deleteRecipe = (recipeId) => async(dispatch) => {
  dispatch(appLoading(true))
  await DB.collection('fishRecipes').doc(recipeId).delete()
  dispatch(appMessage(`{ok}`))
}



// WEBPACK FOOTER //
// ./src/actions/recipesActions.js